import React from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import Container from './Container';

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <div className="footer-content">

          {/* LEFT COLUMN */}
          <div className="footer-about">
            <img src="/logo.png" alt="ELDR Logo" className="footer-logo" />

            <p className="footer-description">
              Securely Store, Access, and Share Your Medical Records Anytime, Anywhere.
              Take control of your health data with our HIPAA-compliant, AWS cloud-based
              medical record storage. Designed for individuals, families, and healthcare providers.
            </p>

            {/* Meeting Box */}
            <div className="footer-meeting">
              <input
                type="text"
                placeholder="Schedule a Meeting"
                className="meeting-input"
              />
              <button className="meeting-btn">Book Now</button>
            </div>
          </div>

          {/* MIDDLE COLUMN */}
          <div className="footer-links">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="#">Home</a></li>
              <li><a href="#">About ELDR-US</a></li>
              <li><a href="#">Services</a></li>
              <li><a href="#">New Product</a></li>
              <li><a href="#">Company Blog</a></li>
              <li><a href="#">Job Opportunities</a></li>
              <li><a href="#">Contact Us</a></li>
            </ul>
          </div>

          {/* RIGHT COLUMN */}
          <div className="footer-links">
            <h3>Contact Us</h3>

            <div className="footer-contact">
              <div className="footer-contact-item">
                <FaPhone />
                <div>
                  <div>779-939-9550</div>
                  <div>855-428-3537 tollfree</div>
                </div>
              </div>

              <div className="footer-contact-item">
                <FaEnvelope />
                <span>info@eldr-us.com</span>
              </div>

              <div className="footer-contact-item">
                <FaMapMarkerAlt />
                <div>
                  <div>6260 East Riverside Blvd.</div>
                  <div>Suite 312, Loves Park, IL 61111</div>
                </div>
              </div>
            </div>

            <div className="footer-team-members">
              <div>
                Elaine Hoyt – President/Founder<br />
                Elaine.hoyt@eldr-us.com
              </div>

              <div>
                Tim Lowe – Exec VP, COO<br />
                Tim.lowe@eldr-us.com
              </div>
            </div>
          </div>

        </div>

        <div className="footer-bottom">
          Copyright © ELDR 2026 All Rights Reserved
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
